import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import api from '../lib/api';

export default function Insights() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get('/articles'); setArticles(data); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="pt-24">
      <section className="bg-forest-950 py-24">
        <div className="max-w-6xl mx-auto px-6 md:px-10">
          <p className="text-sage-400 tracking-[0.3em] text-xs uppercase mb-5 reveal">News & articles</p>
          <h1 className="font-serif text-cream-50 text-5xl md:text-7xl leading-tight reveal">Insights</h1>
          <p className="mt-6 text-cream-100/75 text-lg max-w-2xl reveal">Thought leadership, legal updates and news from the Perrin Myddelton team.</p>
        </div>
      </section>

      <section className="bg-forest-900 py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          {loading ? <p className="text-cream-100/60">Loading articles…</p> : (
            articles.length === 0 ? <p className="text-cream-100/60">No articles have been published yet.</p> : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {articles.map((a, i) => (
                  <Link key={a.id} to={`/insights/${a.slug}`} className="group bg-forest-950 border border-forest-800 hover:border-sage-500/50 transition-colors overflow-hidden animate-fade-up" style={{ animationDelay: `${i * 70}ms` }}>
                    {a.cover && (
                      <div className="aspect-[16/10] overflow-hidden">
                        <img src={a.cover} alt={a.title} className="w-full h-full object-cover opacity-75 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700" />
                      </div>
                    )}
                    <div className="p-6">
                      <p className="text-sage-400 text-[11px] uppercase tracking-[0.25em]">{a.tag}</p>
                      <h3 className="mt-3 font-serif text-cream-50 text-xl leading-snug group-hover:text-sage-400 transition-colors">{a.title}</h3>
                      <p className="mt-3 text-cream-100/70 text-sm leading-relaxed line-clamp-3">{a.excerpt}</p>
                      <span className="mt-5 inline-flex items-center gap-2 text-sage-400 text-xs tracking-widest uppercase">Read More <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" /></span>
                    </div>
                  </Link>
                ))}
              </div>
            )
          )}
        </div>
      </section>
    </div>
  );
}
